import React from 'react'

const Carousel = () => {
    // All images focused on lap spools
    const GALLERY_IMGS = [
        "/assets/marzoli spool3.png",
        "/assets/LH -10 Lap spool3.png",
        "/assets/Cherry hara Sl3.png",
        "/assets/Trutzschler  T-10 lap spool3.png",
        "/assets/Vouk Rd-3002.jpeg",
        "/assets/E-36 Omega lap spool3.png",
    ];
    return (
        <div>
            <section className="ab-gallery">
                <div className="ab-gallery__track">
                    {[...GALLERY_IMGS, ...GALLERY_IMGS].map((src, i) => (
                        <div key={i} className="ab-gallery__item">
                            <img
                                src={src}
                                alt={`Arklon lap spool gallery image ${(i % GALLERY_IMGS.length) + 1}`}
                            />
                        </div>
                    ))}
                </div>
            </section>
        </div>
    )
}

export default Carousel